export default defineAppConfig({
  ui: {
    colors: {
      primary: 'orange',
      neutral: 'slate'
    },
    // Custom semantic color tokens
    variables: {
      light: {
        background: {
          primary: 'white',
          secondary: 'slate-50',
          tertiary: 'slate-100',
        },
        foreground: {
          primary: 'slate-900',
          secondary: 'slate-600',
          muted: 'slate-500',
        },
        border: {
          primary: 'slate-200',
          secondary: 'slate-300',
        },
        accent: {
          primary: 'orange-400',
          secondary: 'orange-300',
        }
      },
      dark: {
        background: {
          primary: 'white', //'slate-950',
          secondary: 'white', //'slate-900',
          tertiary: 'slate-800',
        },
        foreground: {
          primary: 'slate-50',
          secondary: 'slate-300',
          muted: 'slate-400',
        },
        border: {
          primary: 'slate-600',
          secondary: 'slate-500',
        },
        accent: {
          primary: 'orange-400',
          secondary: 'orange-300',
        }
      }
    }
  }
})
